import oa_request from '../utils/oa-request'
import fw_request from '../utils/fw-request'
import request from '../utils/request'

//获取头部待办
export function message(data){
    return request({
        url:'/common/message',
        method:'get',
        params:data
    })
}

//获取代办已读
export function readmsg(data){
    return request({
        url:'/v2/msg/remind/isRead',
        method:'post',
        params:data
    })
}

//读取系统消息
export function readsystem(data){
    return request({
        url:'/v2/msg/msg/read',
        method:'get',
        params:data
    })
} 

//清空消息
export function clearmessage(data){
    return oa_request({
        url:'/system/deal',
        method:'get',
        params:data
    })
}


//保存展示列
export function saveheader(data){
    return oa_request({
        url:'/common/fieldOrder',
        method:'post',
        data
    })
}

//权限展示列
export function authheader(data){
    return oa_request({
        url:'/v3/auth/field_auth/adminHasLine',
        method:'get',
        params:data
    })
}


// 清空公告
export function clearreport(data){
    return request({
        url:'/v2/msg/notice/clear',
        method:'get',
        params:data
    })
}

// 所属部门下拉
export function branch() {
    return oa_request({
        url: '/common/branch',
        method: 'get'
    })
}

//所有客户
export function custom(data) {
    return oa_request({
        url: '/common/allClient',
        method: 'get',
        params:data
    })
}


//客户获取销售机会
// export function customsell(data) {
//     return oa_request({
//         url: '/payback/sell',
//         method: 'get',
//         params:data
//     })
// }


//客户获取销售机会(新增渠道信息)
export function customsell(data) {
    return oa_request({
        url: '/v1/sell/clientSell',
        method: 'get',
        params:data
    })
}

//客户获取合同
export function customcont(data) {
    return oa_request({
        url: '/payback/contract',
        method: 'get',
        params:data
    })
}

//客户合同获取单项明细
export function contdetail(data) {
    return oa_request({
        url: '/payback/single',
        method: 'get',
        params:data
    })
}

//版本号
// export function Vnumber(data) {
//     return oa_request({
//         url: '/common/version',
//         method: 'get',
//         params:data
//     })
// }
export function Vnumber(data) {
    return request({
        url: '/v2/version/index',
        method: 'get',
        params:data
    })
}

//新建版本信息
export function addvnumber(data) {
    return request({
        url: '/v2/version/save',
        method: 'post',
        data
    })
}

//编辑版本信息
export function editvnumber(data) {
    return request({
        url: '/v2/version/edit',
        method: 'post',
        data
    })
}

//删除版本信息
export function delvnumber(data) {
    return request({
        url: 'v2/version/delete',
        method: 'get',
        params:data
    })
}
//外勤
//读取系统消息
export function readsystem_fw(data){
    return fw_request({
        url:'/back/v1/system/read',
        method:'get',
        params:data
    })
} 
//清空消息
export function clearmessage_fw(data){
    return fw_request({
        url:'/back/v1/system/deal',
        method:'get',
        params:data
    })
}

//获取展示列列表
export function tableheader_fw(data) {
    return fw_request({
        url: '/back/v1/common/field_list',
        method: 'get',
        params:data
    })
}

//设置展示列
export function setheader_fw(data) {
    return fw_request({
        url: '/back/v1/common/set_field',
        method: 'post',
        data
    })
}

//获取下拉参数
export function commomsave(data) {
    return oa_request({
        url: '/v3/Parameters/frontUseParam',
        method: 'get',
        params:data
    })
}

//获取客户导出
export function commomexport(data) {
    return oa_request({
        url: '/v3/Client/exportDataQueue',
        method: 'get',
        params:data
    })
}

//获取机会导出
export function commomexport_sell(data) {
    return oa_request({
        url: '/v3/Sell/exportDataQueue',
        method: 'get',
        params:data
    })
}
//获取合同导出
// export function commomexport_contract(data) {
//     return oa_request({
//         url: '/v3/Contract/exportDataQueue',
//         method: 'get',
//         params:data
//     })
// }
export function commomexport_contract(data) {
    return oa_request({
        url: '/v4/contract/exportDataQueue',
        method: 'get',
        params:data
    })
}
//获取回款导出
// export function commomexport_contractback(data) {
//     return oa_request({
//         url: '/v2/pay_back/exportPayBack',
//         method: 'get',
//         params:data
//     })
// }
export function commomexport_contractback(data) {
    return oa_request({
        url: '/v4/payback/exportDataQueue',
        method: 'get',
        params:data
    })
}


//获取行政导出
export function commomexport_exp(data) {
    return oa_request({
        url: '/v3/Administrative/exportData',
        method: 'get',
        params:data
    })
}
//获取成本导出
export function commomexport_out(data) {
    return oa_request({
        url: '/v3/Cost/exportDataQueue',
        method: 'get',
        params:data
    })
}
//获取房屋合同导出
// export function commomexport_housecontract(data) {
//     return oa_request({
//         url: '/v3/HouseContract/exportDataQueue',
//         method: 'get',
//         params:data
//     })
// }

export function commomexport_housecontract(data) {
    return oa_request({
        url: '/v4/housecontract/exportDataQueue',
        method: 'get',
        params:data
    })
}
//获取房屋回款导出
export function commomexport_houseback(data) {
    return oa_request({
        url: '/v3/HouseBack/exportDataQueue',
        method: 'get',
        params:data
    })
}

//我的需求导出列
export function commomexport_execute(data) {
    return fw_request({
        url: '/back/v3/project/need/exportDataQueue',
        method: 'get',
        params:data
    })
}

//我的需求导出列
export function commomexport_house(data) {
    return oa_request({
        url: '/v4/housenum/exportDataQueue',
        method: 'get',
        params:data
    })
}
